import Vue from "vue";
import axios from "axios";
import eventHref from "../eventhref.js";
import formurlencoded from "form-urlencoded";
import $ from "../base.js";
import store from "../../store";

axios.interceptors.response.use(
  response => {
    //console.log(response)
    //return;
    if (
      response.data.message &&
      response.data.message.indexOf("请先登录") > -1
    ) {
      $.data.remove("MemberId");
      $.data.remove("ShopMemberUserToken");
      Vue.prototype.user = null;
      // location.href='/'
      $.ui.toast(response.data.message);
      // store.state.isSowLogin=1;

      return;
    }
    return response;
  },
  error => {
    console.error(error);
    return Promise.reject(error);
  }
);

Vue.directive("follow-scroll", {
  inserted: function(el, binding) {
    let leftIds = [];
    let topIds = [];
    if (binding.value.left) leftIds = binding.value.left;
    if (binding.value.top) topIds = binding.value.top;
    el.onscroll = function(ev) {
      let top = el.scrollTop;
      let left = el.scrollLeft;
      leftIds.forEach(id => {
        document.querySelector(id).scrollLeft = left;
      });
      topIds.forEach(id => {
        document.querySelector(id).scrollTop = top;
      });
    };
  }
});
Vue.directive("show-over", {
  inserted: function(el, binding) {
    let selector = binding.value.selector;
    let css = binding.value.css;
    let ids = binding.value.ids;
    el.onmouseover = () => {
      let trs = el.querySelectorAll(selector);
      trs.forEach((obj, obj_index) => {
        obj.onmouseover = () => {
          obj.className += " " + css;
          ids.forEach(id => {
            let mobj = document.querySelector(id).querySelectorAll(selector)[
              obj_index
            ];
            mobj.className += " " + css;
          });
        };
        obj.onmouseout = () => {
          obj.className = obj.className.replace(" " + css, "");
          ids.forEach(id => {
            let mobj = document.querySelector(id).querySelectorAll(selector)[
              obj_index
            ];
            mobj.className = mobj.className.replace(" " + css, "");
          });
        };
      });
    };
  }
});

//下拉刷新
Vue.directive("drop-down", {
  inserted: function(el, binding) {
    let datas = {
      s: {
        x: 0,
        y: 0
      },
      e: {
        x: 0,
        y: 0
      }
    };
    let _e = null;
    el.ontouchstart = e => {
      datas.s.x = e.touches[0].screenX;
      datas.s.y = e.touches[0].screenY;
      _e = e;
    };
    let isInTow = false;
    el.ontouchmove = e => {
      datas.e.x = e.touches[0].screenX;
      datas.e.y = e.touches[0].screenY;
      if (el.scrollTop == 0 && datas.e.y > datas.s.y) {
        isInTow = true;
        binding.value.callback(datas.e.y - datas.s.y);
      }
    };
    el.ontouchend = () => {
      if (el.scrollTop == 0) {
        let yc = datas.e.y - datas.s.y;
        if (yc > 50 && datas.e.y != 0) {
          binding.value.post("up");
        } else {
          binding.value.post(0);
        }
      }
      datas = {
        s: {
          x: 0,
          y: 0
        },
        e: {
          x: 0,
          y: 0
        }
      };
    };
    el.onscroll = () => {
      if (el.scrollTop >= el.scrollHeight - el.offsetHeight - 100) {
        binding.value.post("down");
      }
    };
  }
});
//手势扩展类
Vue.directive("gesture", {
  inserted: function(el, binding) {
    let datas = {
      s: {
        x: 0,
        y: 0,
        time: new Date()
      },
      e: {
        x: 0,
        y: 0,
        time: new Date()
      }
    };
    let _e = null;
    el.ontouchstart = e => {
      datas.s.x = e.touches[0].screenX;
      datas.s.y = e.touches[0].screenY;
      datas.s.time = new Date();
      _e = e;
    };
    el.ontouchmove = e => {
      datas.e.x = e.touches[0].screenX;
      datas.e.y = e.touches[0].screenY;
      datas.e.time = new Date();
    };
    el.ontouchend = () => {
      let xc = datas.e.x - datas.s.x;
      if (datas.e.time.getTime() - datas.s.time.getTime() < 1) return;
      if (xc > 100) {
        binding.value.callback(1, _e);
      }
      if (xc < -100) {
        binding.value.callback(2, _e);
      }
    };
  }
});

Vue.directive("scroll", {
  inserted: function(el, binding) {
    // console.log(binding)
    let arg = binding.arg;
    let cleanOutSelect = function() {
      try {
        document.selection.empty();
      } catch (exp) {
        try {
          window.getSelection().removeAllRanges();
        } catch (exp) {}
      }
    };
    if (binding.value.value) {
      let length = el.children[0].offsetHeight;

      if (arg == "top") {
        el.scrollTop = binding.value.value * length;
      }
      if (arg == "left") {
        el.scrollLeft = binding.value.value * length;
      }
    }
    el.ontouchstart = function(ev) {
      let length = el.children[0].offsetHeight;

      let et = ev.changedTouches[0];
      let disX = et.clientX - el.offsetLeft;
      let disY = et.clientY - el.offsetTop;
      let thisTop = el.scrollTop;
      let thisLeft = el.scrollLeft;

      document.ontouchmove = function(ev) {
        let et = ev.changedTouches[0];
        let l = et.clientX - disX;
        let t = et.clientY - disY;

        if (arg == "top") {
          el.scrollTop = thisTop - t;
        }
        if (arg == "left") {
          el.scrollLeft = thisLeft - l;
        }
      };
      document.ontouchend = function() {
        if (arg == "top") {
          let mo = el.scrollTop % length;
          let top = 0;
          if (mo > length / 2)
            top = el.scrollTop - (el.scrollTop % length) + length;
          else top = el.scrollTop - (el.scrollTop % length);
          el.scrollTop = top;
          console.log(top);
          //console.log(mo,el.scrollTop , length)
          binding.value.callback(top / length, binding.value);
        }
        if (arg == "left") {
          let mo = el.scrollLeft % length;
          if (mo > length / 2)
            el.scrollLeft = el.scrollLeft - (el.scrollLeft % length) + length;
          else el.scrollLeft = el.scrollLeft - (el.scrollLeft % length);
          binding.value.callback(el.scrollLeft / length);
        }
        document.ontouchmove = null;
        document.ontouchend = null;
      };
    };
  }
});
//数据缓存
let storage = {
  get(key) {
    return $.toJs(localStorage.getItem(key));
  },
  set(key, data) {
    localStorage.setItem(key, JSON.stringify(data));
  },
  remove(key) {
    localStorage.removeItem(key);
  }
};

var base = {
  //判断登录
  isLogin: function(callback) {
    if (!this.user) {
      this.$store.state.isSowLogin = 1;
      this.$store.state.funLogin = callback;
      return false;
    }
    return true;
  },
  //鼠标滑过标签
  hoverTag: function(key) {
    if (window["clear_" + key]) clearTimeout(window["clear_" + key]);
    this[key] = 1;
  },
  //鼠标滑出标签
  outTag: function(key, callback) {
    window["clear_" + key] = setTimeout(() => {
      this[key] = 0;
      callback && callback();
    }, 100);
  },
  //收藏
  favorite: function(sURL, sTitle) {
    sURL = sURL || window.location;
    sTitle = sTitle || document.title;
    try {
      window.external.addFavorite(sURL, sTitle);
    } catch (e) {
      try {
        window.sidebar.addPanel(sTitle, sURL, "");
      } catch (e) {
        $.ui.toast("您的浏览器不支持此操作，请使用Ctrl+D进行添加");
      }
    }
  },
  download(url, data, callback) {
    axios
      .post(url, data, {
        responseType: "blob"
      })
      .then(response => {
        callback(response.data);
      });
  },
  //执行post请求
  post: (url, data, callback, manyKey, hkey, htime, type) => {
    if (hkey) {
      let d = storage.get(hkey);
      if (d) {
        if (htime && d.time) {
          let diffTime = $.date.diff(new Date(d.time), "m", new Date());

          if (diffTime <= 30) {
            callback(base.returnData(d.data, type));
            return;
          }
        } else {
          callback(base.returnData(d.data, type));
          return;
        }
      }
    }
    let token = $.data.get("ShopMemberUserToken");
    let header = {
      "Content-Type": "application/x-www-form-urlencoded"
    };
    if (token) {
      header.Token = token;
    }
    //if(window['isPostData'])return;
    window["isPostData"] = 1;
    axios
      .post(url, formurlencoded(data), {
        headers: header,
        withCredentials: true
      })
      .then(response => {
        window["isPostData"] = 0;
        callback(base.returnData(response.data, type));
        if (hkey) {
          if (response.data.code == "0000") {
            storage.set(hkey, {
              data: response.data,
              time: new Date()
            });
          }
        }
      });
  },
  postJson: (url, data, callback, manyKey, hkey, htime, type) => {
    if (hkey) {
      let d = storage.get(hkey);
      if (d) {
        if (htime && d.time) {
          let diffTime = $.date.diff(new Date(d.time), "m", new Date());

          if (diffTime <= 30) {
            callback(base.returnData(d.data, type));
            return;
          }
        } else {
          callback(base.returnData(d.data, type));
          return;
        }
      }
    }
    let token = $.data.get("ShopMemberUserToken");
    let header = {
      "Content-Type": "application/json"
    };
    if (token) {
      header.Token = token;
    }
    //if(window['isPostData'])return;
    window["isPostData"] = 1;
    axios
      .post(url, data, {
        headers: header,
        withCredentials: true
      })
      .then(response => {
        window["isPostData"] = 0;
        callback(base.returnData(response.data, type));
        if (hkey) {
          if (response.data.code == "0000") {
            storage.set(hkey, {
              data: response.data,
              time: new Date()
            });
          }
        }
      });
  },
  post2: function(url, data, callback) {
    var ths = this;
    var token = $.data.get("ShopMemberUserToken");
    var header = {
      Token: token
    };
    axios
      .post(url, data, {
        headers: header
      })
      .then(response => {
        callback && callback(response.data);
      });
  },
  postAll(funs) {
    axios.all(funs).then(responseList => {
      callback &&
        callback(
          responseList.map(response => {
            return response.data;
          })
        );
    });
  },
  postFile(url, file, callback) {
    let token = $.data.get("token");

    const formData = new FormData();
    formData.append("file", file);
    if (token) {
      formData.append("token", token);
    }
    axios
      .post(url, formData, {
        transformRequest: [
          (data, headers) => {
            headers.post["Content-Type"] = "application/x-www-form-urlencoded";
            return data;
          }
        ]
      })
      .then(response => {
        callback && callback(response.data);
      });
  },
  postImage(url, formData, callback) {
    let headers = {};
    const token = $.data.get("token");
    if (token) headers.token = token;

    axios
      .post(url, formData, {
        transformRequest: [
          (data, headers) => {
            headers.post["Content-Type"] = "application/x-www-form-urlencoded";
            return data;
          }
        ]
      })
      .then(response => {
        callback && callback(response.data);
      });
  },
  returnData: (data, type) => {
    if (type != null) {
      let d = {};
      data[type["field"]].forEach(item => {
        d[item[type["key"]]] = item;
      });
      return d;
    } else {
      return data;
    }
  },
  //执行get请求
  get: (url, data, callback, hkey, htime, type) => {
    if (hkey) {
      let d = storage.get(hkey);
      if (d) {
        if (htime && d.time) {
          let diffTime = $.date.diff(new Date(d.time), "m", new Date());
          if (diffTime <= 30) {
            callback(base.returnData(d.data, type));
            return;
          }
        } else {
          callback(base.returnData(d.data, type));
          return;
        }
      }
    }
    let token = $.data.get("ShopMemberUserToken");
    let header = null;
    if (token) {
      header = {
        Token: token
      };
    }

    axios
      .get(url, {
        params: data,
        headers: header
      })
      .then(response => {
        if (response.data) {
          callback(base.returnData(response.data, type));
        }
        if (hkey) {
          if (response.data.code == "0000") {
            storage.set(hkey, {
              data: response.data,
              time: new Date()
            });
          }
        }
      })
      .catch(error => {
        console.log(error);
      });
  },
  get2: (url, data, callback) => {
    axios
      .get(url, {
        params: data
      })
      .then(response => {
        callback(response);
      });
  },
  //获取标签数据
  getData: function(e) {
    return e.currentTarget.dataset;
  },
  //跳转页
  href: function(e, data, callback) {
    let path = "";
    let _data = {};
    if (e.constructor == String) {
      path = e;
      _data = data;
    } else {
      let data = this.getData(e);
      path = data.path;
      for (let key in data) {
        if (key != "path") _data[key] = data[key];
      }
    }

    let attr = $._param(_data);
    if (attr != "") {
      path += (path.indexOf("?") > -1 ? "&" : "?") + attr;
    }

    if (callback) {
      eventHref.$on("pageCallBack", data => {
        callback(data);
        eventHref.$off("pageCallBack");
      });
    }

    this.$router.push({
      path: path
    });
  },
  //返回上一页
  back: function(data) {
    if (data) {
      eventHref.$emit("pageCallBack", data);
    }
    this.$router.go(-1);
  },
  //扩展
  extend: (data1, data2) => {
    for (let _key in data2) {
      data1.prototype[_key] = data2[_key];
    }
  }
};
export default base;



// WEBPACK FOOTER //
// ./src/helpers/vue/base.js